export default __webpack_public_path__ + "static/media/thirddash.c5a66791.svg";